import HeroImage from "../assets/hero.png";
// import HeroImage2 from "../assets/hero2.png";

export class Hero {
  x: number;
  y: number;
  width: number;
  height: number;
  status: "left" | "right" | "stop";
  image: HTMLImageElement;
  originY: number;
  hitboxX: number;
  hitboxY: number;
  hitboxWidth: number;
  hitboxHeight: number;

  constructor(x: number, y: number) {
    this.x = x;
    this.y = y;

    this.originY = y;

    this.width = 50;
    this.height = 50;
    this.status = "stop";

    this.hitboxX = x + 10;
    this.hitboxY = y + 18;
    this.hitboxWidth = 30;
    this.hitboxHeight = 30;

    this.image = new Image();
    this.image.src = HeroImage;
  }

  leftMove() {
    if (this.x > 0) {
      this.x -= 5;
      this.hitboxX -= 5;
    }
  }

  rightMove(maxX: number) {
    if (maxX >= this.x) {
      this.x += 5;
      this.hitboxX += 5;
    }
  }

  draw(ctx: CanvasRenderingContext2D) {
    ctx.fillStyle = "green";
    // ctx.fillRect(
    //   this.hitboxX,
    //   this.hitboxY,
    //   this.hitboxWidth,
    //   this.hitboxHeight
    // );
    // ctx.drawImage(
    //   this.image,
    //   50,
    //   50,
    //   this.image.width - 100,
    //   this.image.height - 160,
    //   this.x,
    //   this.y,
    //   this.width,
    //   this.height
    // );
    ctx.drawImage(this.image, this.x, this.y, this.width, this.height);
  }
}
